



























import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderAddButton,
    BuilderButton,
    BuilderTooltip,
    BuilderDot
  },
})
export default class BuilderProfileAvatar extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  @Ref('file') readonly fileInput!: HTMLInputElement
  
  processing = false

  get avatar(): File | string | undefined {
    return this.value.avatar
  }

  set avatar(value: File | string | undefined) {
    this.$emit('input', { avatar: value })
  }

  get isNextStepDisabled(): boolean {
    return !this.avatar
  }

  onFileChange(files: File[]): void {
    const file = files[0]
    const { type } = file

    if (!type) { return }

    const isImage = type.includes('image')
    const isGif = isImage && type.includes('image/gif')

    if (isImage && !isGif) {
      this.avatar = file
    }
  }

  onUploadPhotoClick(): void {
    if (!this.avatar) {
      this.fileInput.click()
    } else {
      this.avatar = undefined
    }
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }

    if (this.avatar instanceof File) {
      this.processing = true
      
      try {
        await this.$store.dispatch('builder/setProfileAvatar', {
          avatar: this.avatar,
        })

        this.$emit('next')
      } catch (e) {
        this.$toasted.error(e.message)
      }
    } else {
      this.$emit('next')
    }

    this.processing = false
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'avatar',
      blurCover: true,
      blurSubscriptions: true,
      blurContentType: true,
      blurPosts: true
    })
  }
}
